// full updated code (starts here)
import React, { useState, useEffect } from "react";
import Select from "react-select";
import classes from './UploadJournalBulk.module.css';
import HeaderNav from '../../Accoungting/HeaderNav/HeaderNav';
import Footer from "../../Accoungting/Footer/Footer";
import { Trash2 } from "lucide-react";
import axios from "axios";
import { BASE_URL } from '../../../Components/Styles/API/API';
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import CurrencyInput from 'react-currency-input-field';
import download from "../../../Assets/download1.svg"
import { useLocation, useNavigate } from "react-router-dom";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import RotatingLogo from '../../../Assets/rotating-logo.png';
import { Navbar, Nav, NavDropdown, Button, Modal, Form, Tooltip, Badge, OverlayTrigger } from 'react-bootstrap';



const initialState = (tableData) => {
  if (tableData && tableData.length > 0) {
    return tableData.map(item => ({
      accountCode: item.gl_code || '',
      accountName: item.gl_name || '',
      accountType: item.category?.description || '',
      accountId: item.id,
      DR_CR: '',
      amount: '',
    }));
  } else {
    return [{
      accountCode: '', accountName: '', accountType: '', DR_CR: '', amount: '', accountCategory: ''
    }];
  }
};

const BulkEntries = () => {
  // const token = localStorage.getItem("userToken");
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [reference, setReference] = useState("");
  const [transactionDate, setTransactionDate] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [bearer, setBearer] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [provinceID, setProvinceID] = useState('');
  const [currentMonth, setCurrentMonth] = useState('');
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedImage, setSelectedImage] = useState('');
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [balances, setBalances] = useState([]);
  const [totalAmountCredit, setTotalAmountCredit] = useState('');
  const [totalAmountDebit, setTotalAmountDebit] = useState('');
  const [isEqual, setIsEqual] = useState(false);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [createLoading, setCreateLoading] = useState('');
  const [formData, setFormData] = useState([]);
  const [token, setToken] = useState([]);


  const readData = async () => {
    try {
      const value = localStorage.getItem('userToken');
      const provinceid = localStorage.getItem('provinceID');
      const current = await localStorage.getItem('currentMonth');
      const values = await localStorage.getItem('userToken');
      

      if (value !== null) {
        setBearer(value);
        console.log(value);
      }

      if (values !== null) {
        setToken(values);
        console.log(values);
      }
      if (provinceid !== null) {
        setProvinceID(provinceid);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);
      
        setCurrentMonth(date);
      
        const startOfDateRange = new Date(1900, 0, 1);
     
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      
        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); 
          const day = String(date.getDate()).padStart(2, '0');     
          return `${year}-${month}-${day}`;
        };
      
        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
      }

    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);
  // Fetch accounts for dropdown

  const calculateTotalAmount = () => {
    const total = formData.reduce((acc, item) => {
      return item.DR_CR === '1' ? acc + parseFloat(item.amount || 0) : acc;
    }, 0);

    const formattedTotal1 = total.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    setTotalAmountDebit(formattedTotal1);
  };

  const calculateTotalAmountCredit = () => {
    const total = formData.reduce((acc, item) => {
      return item.DR_CR === '2' ? acc + parseFloat(item.amount || 0) : acc;
    }, 0);

    const formattedTotal = total.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    setTotalAmountCredit(formattedTotal);
  };



  useEffect(() => {
    calculateTotalAmount();
    calculateTotalAmountCredit();
  }, [formData]);

  useEffect(() => {
    // Update formData whenever tableData changes
    setFormData(initialState(tableData));
  }, [tableData]);



  const deleteRow = (index) => {
    const updatedData = formData.filter((_, i) => i !== index);
    setFormData(updatedData);
  };

  const handleFormChange = (index, field, value) => {
    let formattedValue = value;

    // Format the amount field
    if (field === 'amount' && value !== '') {
      formattedValue = (Number(value.replace(/\D/g, '')) || '').toLocaleString();
    }

    const updatedFormData = [...formData];
    updatedFormData[index][field] = formattedValue;
    setFormData(updatedFormData);
  };



  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };

  const fetchCharts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account`, { headers });
      const results = response.data?.data;
      setTableData(results);
      console.log(response);

    } catch (error) {
      if (error.response && error.response.status === 401) {

        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setTableData([]);
      }
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (bearer) {
      fetchCharts();

    }
  }, [bearer]);




  const addRow = () => {
    const newRow = {
      accountCode: '', accountName: '', accountType: '', DR_CR: '', amount: '', accountCategory: ''
    };

    setFormData([...formData, newRow]);
  };




  const createJournal = async () => {
    const confirmed = await Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to save this.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!',
      cancelButtonText: 'No, cancel',
    });

    if (!confirmed.isConfirmed) {
      return;
    }

    setBalanceLoading(true);

    try {
      // Filter rows that have a valid amount before mapping
      const filteredFormData = formData.filter((row) => row.amount && row.amount.trim() !== '');

      const accountIds = filteredFormData.map((row) => row.accountId).filter((id) => id);
      const directions = filteredFormData.map((row) => row.DR_CR).filter((value) => value);
      const descriptions = filteredFormData.map((row) => row.description).filter((value) => value);
      const amounts = filteredFormData.map((row) => row.amount).filter((value) => value);

      const creditAmount = totalAmountCredit.replace(/,/g, '').replace(/\.00$/, '');
      const debitAmount = totalAmountDebit.replace(/,/g, '').replace(/\.00$/, '');

      const response = await axios.post(`${BASE_URL}/journal/opening-balance-bulk`,
        {
          account_id: accountIds,
          all_credit: creditAmount,
          all_debit: debitAmount,
          amount: amounts,
          direction: directions,
          transaction_date: selectedDate
        },
        { headers }
      );
      fetchCharts();
      setFormData([]);
      setSelectedDate('');
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: JSON.stringify(error.response.data.message),
      });
      console.log(errorMessage);
    } finally {
      setBalanceLoading(false);
    }
  };


  const handleValueChange1 = (value, index) => {
    const updatedFormData = [...formData];
    updatedFormData[index] = {
      ...updatedFormData[index],
      amount: value,
    };
    setFormData(updatedFormData);
  };


  useEffect(() => {
    calculateTotalAmount();
    calculateTotalAmountCredit();
  }, [formData]);

  useEffect(() => {
    // Compare the total debit and total credit values
    setIsEqual(totalAmountDebit === totalAmountCredit);
  }, [totalAmountDebit, totalAmountCredit]);

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  // console.log(formData, "jsklfj");

  return (
    <div>
      <HeaderNav />
                              {createLoading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}
                              {balanceLoading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}


      <div className={classes.Container}>
        <header className={classes.Header}>
          <h2 className={classes.Title}> Upload Opening Balance - Bulk </h2>
          <div style={{}}>
          <div className={`col-md-4 ${classes.mblrow}`} style={{ marginLeft: 30 }}>
                      <div className="form-group row">
                        <label htmlFor="example-text-input" className={`col-sm-8 col-form-label font-weight-400 ${classes.lblrow} ${classes.lblrow2}`}>Transaction Date:</label>
                        <div className="col-sm-8">
                          <input className="form-control" required="" type="date" onChange={handleDateChange} name="date" value={selectedDate}
                            min={minDate}
                            max={maxDate}
                            style={{ width: "200px", marginLeft: 5 }} />
                        </div>
                      </div>
                    </div>
</div>
        </header>
       
        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
          <thead style={{ whiteSpace: "nowrap", textAlign: "left", }}>
                                      <tr>
                                        <th>Account Code</th>
                                        <th style={{ width: '10%', }}>Account Name</th>
                                        <th>Account Type</th>
                                        <th style={{ width: '15%', }}>DR/CR</th>
                                        <th style={{ width: '15%', }}>Amount</th>

                                        <th>
                                          <div  onClick={() => addRow()}
                                          style={{cursor: "pointer"}}
                                          >
                                          +
                                          </div>
                                        </th>

                                      </tr>
                                    </thead>
          
                                    {isLoading ? (
                                      <p>Fetching data...</p>
                                    ) : (
                                      <tbody style={{ whiteSpace: "nowrap", }}>
                                        {formData.map((row, index) => (
                                          <tr key={index}>
                                            <td>{row.accountCode} </td>
                                            <td>{row.accountName}</td>
                                            <td> {row.accountType} </td>
                                            <td >

                                              <Form.Select
                                                value={row.DR_CR}
                                                onChange={(e) => handleFormChange(index, 'DR_CR', e.target.value)}
                                                className="form-control"
                                                style={{ height: 30, fontSize: 12, }}
                                              >
                                                <option value="">Select</option>
                                                <option value="1">DR</option>
                                                <option value="2">CR</option>
                                              </Form.Select>

                                            </td>
                                            <td>
                                              <CurrencyInput
                                                name={`rowAmount ${index}`} // Provide a unique name for each CurrencyInput
                                                decimalsLimit={2}
                                                value={row.amount}
                                                className="form-control"
                                                onValueChange={(value) => handleValueChange1(value, index)}
                                                style={{ textAlign: "right", border: "none", height: 30, fontSize: 12, }}
                                              />

                                            </td>


                                            <td >
                                              <div  style={{display: "flex", alignItems: "center", justifyContent: "center"}} onClick={() => deleteRow(index)}>
                                              <Trash2 size={16} className={classes.deleteIcon} />
                                                {/* <i className="far fa-trash-alt" style={{ color: "#dc3545", backgroundColor: "#dc35451a", padding: 2, borderColor: "#dc35454d", borderRadius: 5, fontSize: 12 }}></i> */}
                                              </div>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    )}


          </table>

          <div style={{ marginTop: 40 }} />
            <div className={classes.form_align}>
                 <Form.Group className="mb-3">
                  <Form.Label>Total Debit:</Form.Label>
                    <Form.Control
                      type="text"
                      value={totalAmountDebit}
                      name="total"
                      readOnly
                      style={{ textAlign: 'right' }}
                      />
                      </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Total Credit:</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={totalAmountCredit}
                                    name="total"
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                  />
                                </Form.Group>
                              </div>


                              <div class={`modal-footer ${classes.overlaybtn100}`} style={{ marginTop: '20px', paddingRight: '20px' }}>
                                <button
                                 className={classes.loanBtn}
                                  // className={classes.longbtn}
                                  onClick={createJournal}
                                  disabled={!isEqual}
                                  style={{ padding: '5px 30px' }}>
                                  Save
                                </button>
                              </div>
          {/* <div className={classes.foot}>
            <div className={classes.Footer}>
              <div className={`${classes.footerSection} ${classes.comments}`}>
                <label>Message</label>
                <textarea className={classes.commentsBox}></textarea>
              </div>

              <div className={`${classes.footerSection} ${classes.summary}`}>
                <div className={classes.grouppp}>
                  <label>Total Debit:</label>
                  <input
                    type="text"
                    value={totalDebit.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>
                <div className={classes.grouppp}>
                  <label>Total Credit:</label>
                  <input
                    type="text"
                    value={totalCredit.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>
                <div className={classes.actionButtons}>
                  <button className={classes.cancelButton} type="button" onClick={() => setJournalRows([{
                    account: null,
                    account_id: "",
                    account_code: "",
                    description: "",
                    direction: "",
                    amount: ""
                  }])}>
                    Cancel
                  </button>
                  <button
                    className={classes.saveButton}
                    type="button"
                    onClick={handleSaveJournal}
                    disabled={isSaving}
                  >
                    {isSaving ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          className="me-2"
                        />
                        Saving...
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default BulkEntries;
